<div class="pageheader">
  <div class="page-title">
    <h1>Mail Log</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
    </div>
  </div>
</div>

<dx-data-grid biz-grid [dataSource]="log" [masterDetail]="{ enabled: true, template: 'detailView' }">
  <dxi-column dataField="Id" width="5%" caption="Id" dataType="number" [allowGrouping]="false" [allowFiltering]="false"
    [visible]="false">
  </dxi-column>
  <dxi-column dataField="Timestamp" width="10%" caption="Timestamp" dataType="date" [allowGrouping]="false"
  sortOrder="desc" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
  <dxi-column caption="Attachments" width="5%" dataType="boolean" [allowFiltering]="false"
    [calculateCellValue]="hasAttachments">
  </dxi-column>
  <dxi-column dataField="From" width="10%" caption="From" dataType="string"></dxi-column>
  <dxi-column dataField="To" width="10%" caption="To" dataType="string"></dxi-column>
  <dxi-column dataField="Subject" width="20%" caption="Subject" [allowGrouping]="false" [allowFiltering]="false"
  dataType="string"></dxi-column>
  <dxi-column dataField="Body" width="40%" caption="Body (partial)" [allowGrouping]="false" [allowFiltering]="false"
    dataType="string">
  </dxi-column>

  <ng-container *dxTemplate="let cellInfo of 'detailView'">
    <div class="detail__frame">

      <div class="detail-group detail-group__body">
        <label>Body (partial)</label>
        <textarea readonly>{{ cellInfo.data.Body }}</textarea>
      </div>

      <div class="detail-group detail-group__attachments">
        <label>Attachments</label>
        @if (cellInfo.data.Attachments.length < 1) {
          <div>
            <p class="detail-group__attachments--dimmed">No attachments present</p>
          </div>
        }
        @if (cellInfo.data.Attachments.length > 0) {
          <dx-data-grid biz-grid [dataSource]="cellInfo.data.Attachments"
            [bizSetColumnChooser]="false" [bizSetAllowColumnReordering]="false" [bizHideSelectedRowsComponent]="true"
            [showResetButton]="false" [bizSetGroupPanel]="false" [bizSetPager]="false" [bizSetSearchPanel]="false">
            <dxi-column dataField="Filename" width="80%" caption="Filename" dataType="string"></dxi-column>
            <dxi-column dataField="Size" width="20%" caption="Size" dataType="number"></dxi-column>
          </dx-data-grid>
        }
      </div>

      <div class="detail-group detail-group__settings">
        <label>Settings</label>
        <biz-json-viewer [objectToShow]="cellInfo.data.SmtpSettings"></biz-json-viewer>
      </div>
    </div>
  </ng-container>
</dx-data-grid>
